import React from 'react';
import '../css/contact.css';

const ThankYou = () => {
    return (
        <div
            style={{
                maxWidth: '600px',
                margin: '3rem auto',
                padding: '2rem',
                textAlign: 'center',
                backgroundColor: '#f9f9f9',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            }}
        >
            <h2 style={{ marginBottom: '1rem', color: '#444' }}>
                Thank you for your submission.
            </h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#444' }}>
                Someone will get back to you shortly.<br />
                <strong>Yacht Rock On! 🎶</strong>
            </p>
        </div>
    )
}
export default ThankYou;